/// <reference path="../functions.ts" />
/// <reference path="customstorage.ts" />
/// <reference path="../interfaces/istoragebase.ts" />

module App.Classes {
    export class StorageBase implements App.Interfaces.IStorageBase {
        constructor(private storageType: Storage) {
            // If the requested storage is not available, load it in a custom temporary storage
            // This temporary storage is cleared every page refresh
            if (!App.Functions.storageExists(storageType))
                this.storageType = new App.Classes.CustomStorage();
        }

        get<T>(key: string, defaultValue?: T): T {
            var result = this.storageType.getItem(key);
            if (result && result != 'undefined' && result != 'null')
                return JSON.parse(this.storageType.getItem(key));
            return defaultValue;
        }
        set<T>(key: string, value: T): void {
            this.storageType.setItem(key, JSON.stringify(value));
        }
    }
}